/* eslint-disable no-else-return */
/* eslint-disable no-secrets/no-secrets */

/* eslint-disable padding-line-between-statements */
import React, { useEffect, useState, useContext, useCallback, useMemo } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import { AdditionalInterestComponent, AddressStandardizationComponent, SearchContactComponent } from 'premier-capability-policyjob-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { ToastProvider } from '@jutro/components';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import appConfig from 'app-config';
import metadata from './PolicyDetailsPage.metadata.json5';
import styles from './PolicyDetailsPage.module.scss';
import messages from './PolicyDetailsPage.messages';

const calculateMonth = (startDate, countMonth) => {
    const halfYearDate = moment(startDate).add(countMonth, 'M');

    return {
        day: halfYearDate.format('D'),
        month: halfYearDate.format('M') - 1,
        year: halfYearDate.format('YYYY'),
    };
};

const getPeriodEndDate = (periodStartDate, periodEndDate, termType) => {
    if (termType === 'HalfYear') {
        return calculateMonth(periodStartDate, 6);
    }

    if (termType === 'Annual') {
        return calculateMonth(periodStartDate, 12);
    }

    return periodEndDate;
};

function PolicyDetailsPage(props) {
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { updateSubmission } = useUpdateSubmissionServices();
    const { initialValidation, isComponentValid, onValidate } = useValidation('PolicyDetailsPage');
    const { wizardData: submissionVM, updateWizardData, history } = props;
    const { authHeader } = useAuthentication();
    const [producerCodes, setProducerCodes] = useState([]);
    const [accountLocations, setAccountLocations] = useState([]);
    const [mailingAddress, setMailingAddress] = useState(null);
    const [addOrEditMailLocation, setAddOrEditMailLocation] = useState({ mode: null, location: null });
    const [accountContacts, setAccountContacts] = useState([]);
    const [primaryNamedInsured, setPrimaryNamedInsured] = useState([]);
    const [isSearchContact, setIsSearchContact] = useState(false);
    const accountNumber = _.get(submissionVM, 'baseData.accountNumber.value');
    const isNewSubmission = useMemo(() => history.location.state ? history.location.state.quoteentry.isNewSubmission : false, [history]);
    
    const { lineName } = PremierConstants;
    const productCode = _.get(submissionVM.value, 'baseData.productCode');
    // eslint-disable-next-line security/detect-object-injection
    const lobLineName = productCode ? lineName[productCode] : '';

    const offeringCode = _.get(submissionVM.value, `lobData.${lobLineName}.selectedOffering_Ext`);


    const updateLocationAndSetPolicyAddress = useCallback(() => {
        const locations = _.get(submissionVM, 'baseData.primaryNamedInsured_Ext.accountLocations_Ext.value');
        locations.map((loc) => {
            const location = loc;
            location.id = loc.publicID;
            location.name = loc.displayName;
            return loc
        });
        setAccountLocations(locations);

        const policyAddress = _.get(submissionVM, 'baseData.policyAddress.value');
        const matchingLocation = _.find(locations, (location) => location.publicID === policyAddress.publicID);
        if (!_.isUndefined(matchingLocation)) {
            setMailingAddress(matchingLocation);
        }
    }, [submissionVM]);

    useEffect(() => {
        const insured = submissionVM.baseData.primaryNamedInsured_Ext.value
        const contacts = _.get(submissionVM, 'baseData.account_Ext.accountContacts_Ext.value')
            .map((c) => {
                const contact = c;
                contact.id = contact.publicID;
                if (contact.publicID === insured.publicID) {
                    setPrimaryNamedInsured(contact)
                }
                return c;
            });
            
        if (appConfig.unsupportedOfferingForFR.includes(offeringCode)) {
            _.set(submissionVM, 'baseData.preferredlanguage_Ext.value', 'EnglishCA');
        }

        setAccountContacts(contacts);

        // If search is need uncomment the below code
        /*  setAccountContacts(
             [
                 { id: "existing", displayName: translator(messages.searchExistingContact) }
             ].concat(contacts) 
         ); 
 
         const accProducerCodes = [];
         const producerCodesPromise = OrganizationService.getProducerCodeForOrganization(
             submissionVM.baseData.value.account_Ext.producerCodes[0].organizationDTO_Ext,
             authHeader
         );
         producerCodesPromise.then((producerCodesResponse) => {
             _.each(producerCodesResponse, (producerCodeValue) => {
                 accProducerCodes.push({ code: producerCodeValue.code, name: producerCodeValue.displayValue });
             });
             setProducerCodes(accProducerCodes);
         }); */

        updateLocationAndSetPolicyAddress();

    }, [authHeader, submissionVM, submissionVM.baseData.value.account_Ext.producerCodes, translator, updateLocationAndSetPolicyAddress]);

    const onPrimaryInsuranceChange = async (value) => {
        setIsSearchContact(false);
        if (value === "existing") {
            setIsSearchContact(true);
        } else {
            const contact = accountContacts.filter((c) => c.publicID === value)[0];
            const jobID = _.get(submissionVM, 'quoteID.value');
            if (!_.isUndefined(contact)) {
                const response = await LoadSaveService.updatePrimaryNamedInsured_Ext(jobID, value, authHeader)
                _.set(submissionVM, 'baseData.primaryNamedInsured_Ext.value', response);
                _.set(submissionVM, 'baseData.policyAddress.value', response.primaryAddress);

                updateLocationAndSetPolicyAddress();
                setPrimaryNamedInsured(contact);
                updateWizardData(submissionVM);
            }
        }
    }

    const onAddExistingContact = async (accountContact) => {
        const jobID = _.get(submissionVM, 'quoteID.value');
        _.set(submissionVM, 'baseData.primaryNamedInsured_Ext.value', accountContact);
        const insured = submissionVM.baseData.primaryNamedInsured_Ext.value;
        const accountContactsList = await LoadSaveService.getAccountContacts_Ext(jobID, authHeader)
        const contacts = accountContactsList
            .map((c) => {
                const contact = c;
                contact.id = contact.publicID;
                if (contact.publicID === insured.publicID) {
                    setPrimaryNamedInsured(contact)
                }
                return c;
            });

        setAccountContacts(contacts);

        // If search is need uncomment the below code
        /*  setAccountContacts(
             [{ id: "existing", displayName: translator(messages.searchExistingContact) }].concat(contacts)
         ); */
        setIsSearchContact(false);

    }

    const onSearchCancel = () => {
        setIsSearchContact(false);
    }

    const createLocationVM = (model) => {
        const locationVM = viewModelService.create(
            model,
            'pc',
            'edge.capabilities.address.dto.AddressDTO'
        );
        return locationVM
    };

    const onMailingAddressChange = (value) => {
        const matchingLocation = _.find(accountLocations, (location) => location.publicID === value);
        _.set(submissionVM, 'baseData.policyAddress.value', matchingLocation);
        setMailingAddress(matchingLocation);
    }

    const onPreferredLanguageChange = useCallback((value) => {
        ToastProvider.toast({
            type: 'warning',
            message: translator(messages.preferredLanguage),
            autoClose: true
        });
        _.set(submissionVM, 'baseData.preferredlanguage_Ext.value', value);
        updateWizardData(submissionVM);
    }, [submissionVM, translator, updateWizardData])

    const getPreferredLanguageAvailableValues = useCallback(() => {
        if (appConfig.unsupportedOfferingForFR.includes(offeringCode)) {
            return _.filter(submissionVM.baseData.preferredlanguage_Ext.aspects.availableValues, (item) => item.code !== PremierConstants.preferredFrenchCode)
            .map((typeCode) => ({
                    code: typeCode.code,
                    name: translator({
                        id: typeCode.name,
                        defaultMessage: typeCode.name
                    })
                }));
        } else {
            return submissionVM.baseData.preferredlanguage_Ext.aspects.availableValues
                .map((typeCode) => ({
                    code: typeCode.code,
                    name: translator({
                        id: typeCode.name,
                        defaultMessage: typeCode.name
                    })
                }));
        }

    }, [offeringCode, submissionVM, translator])

    const onAddNewLocationClick = () => {
        const newLocationVM = createLocationVM({ country: 'CA' })
        setAddOrEditMailLocation({ mode: 'add', location: newLocationVM });
    }

    const onEditLocationClick = () => {
        const editLocationVM = createLocationVM(mailingAddress)
        setAddOrEditMailLocation({ mode: 'edit', location: editLocationVM });
    }

    const createUpdateLocation = async () => {
        const jobID = _.get(submissionVM, 'quoteID.value');
        const additionNamedInsuredList = _.get(submissionVM, 'baseData.AdditionalNamedInsureds_Ext.value');
        submissionVM.value = await LoadSaveService.addOrUpdatePolicyAddress_Ext(jobID, addOrEditMailLocation.location.value, authHeader);
        _.set(submissionVM, 'baseData.AdditionalNamedInsureds_Ext.value', additionNamedInsuredList)
        updateLocationAndSetPolicyAddress();
        updateWizardData(submissionVM);
        setAddOrEditMailLocation({ mode: null, location: null });
    }

    const onAddressUpdate = (value, path) => {
        const updatedAddOrEditMailLocation = addOrEditMailLocation;

        updatedAddOrEditMailLocation.location = viewModelService.clone(addOrEditMailLocation.location)

        if (path) {
            _.set(updatedAddOrEditMailLocation, `location.${path}`, value)
        } else {
            _.set(updatedAddOrEditMailLocation, `location.value`, value)
        }

        setAddOrEditMailLocation(updatedAddOrEditMailLocation);
        updateWizardData(submissionVM);
    }

    const onCancelAddressClick = () => {
        setAddOrEditMailLocation({ mode: null, location: null });
    }

    const onNext = useCallback(async () => {
        _.unset(submissionVM.value, 'bindData');
        submissionVM.value = await LoadSaveService.updateDraftSubmission(
            submissionVM.value,
            authHeader
        );
        return submissionVM;
    }, [authHeader, submissionVM]);

    const onSave = useCallback(async () => {
        _.unset(submissionVM.value, 'bindData');

        const subVMCopy = _.clone(submissionVM);

        validationUtil.unSetIsValidationReqFlag(subVMCopy.baseData.value, ' ');

        const response = await updateSubmission('', 'PolicyDetailsPage', subVMCopy);

        submissionVM.value = response;
        updateWizardData(submissionVM)

        return submissionVM;
    }, [authHeader, submissionVM]);

    const getAddOrSaveDisabled = () => {
        if (addOrEditMailLocation && addOrEditMailLocation.location) {
            return addOrEditMailLocation.location.aspects.valid && addOrEditMailLocation.location.aspects.subtreeValid
        }
        return false
    }

    const onValueChangeTermType = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        const periodStartDate = _.get(submissionVM, 'baseData.periodStartDate.value');
        const currentPeriodEndDate = _.get(submissionVM, 'baseData.periodEndDate.value');

        _.set(newSubmissionVM, path, value);
        _.set(newSubmissionVM, 'baseData.periodEndDate.value', getPeriodEndDate(periodStartDate, currentPeriodEndDate, value));
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const onValueChangeCoverageStartDate = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        const termType = _.get(submissionVM, 'baseData.value.termType');
        const currentPeriodEndDate = _.get(submissionVM, 'baseData.periodEndDate.value');

        _.set(newSubmissionVM, path, value);
        _.set(newSubmissionVM, 'baseData.periodEndDate.value', getPeriodEndDate(value, currentPeriodEndDate, termType));
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const getAssociationCodes = () => {

        if (offeringCode === 'MotCyc') {

            return submissionVM.baseData.memberOfAssociationClubMC_Ext.aspects.availableValues.map((key) => ({
                code: key.code,
                name: translator({
                    id: key.name,
                    defaultMessage: key.name
                })
            }));
        }

        else {
            return submissionVM.baseData.memberOfAssociationClubOffRoad_Ext.aspects.availableValues.map((key) => ({
                code: key.code,
                name: translator({
                    id: key.name,
                    defaultMessage: key.name
                })
            }));

        }
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            showRequired: true
        },
        primaryNamedInsured: {
            availableValues: accountContacts,
            value: primaryNamedInsured,
            onValueChange: onPrimaryInsuranceChange
        },
        searchContact: {
            visible: isSearchContact,
            viewModelService,
            authHeader,
            accountNumber,
            handleAddExistingContact: onAddExistingContact,
            handleCancel: onSearchCancel
        },
        mailingAddress: {
            visible: false,
            availableValues: accountLocations,
            value: mailingAddress,
            onValueChange: onMailingAddressChange
        },
        coverageStartDate: {
            minDate: new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Toronto' }))
        },
        additionalInterest: {
            value: submissionVM,
            path: 'baseData.additionalNamedInsureds_Ext',
            type: 'additionalInsured',
            onValueChange: updateWizardData,
            onValidate,
            authHeader
        },
        submissionProducerCode: {
            availableValues: producerCodes
        },
        locationButtonContainer: {
            visible: false
        },
        addressLookupContainer: {
            visible: !!addOrEditMailLocation.mode,
        },
        addressStandarization: {
            model: addOrEditMailLocation.location ? addOrEditMailLocation.location : {},
            onValidate,
            viewModelService,
            onValueChange: onAddressUpdate,
            labelPosition: 'left'
        },
        addNewLocationButton: {
            disabled: !!addOrEditMailLocation.mode,
            onClick: onAddNewLocationClick
        },
        editLocationButton: {
            disabled: !!addOrEditMailLocation.mode,
            onClick: onEditLocationClick
        },
        addAddressButton: {
            disabled: !getAddOrSaveDisabled(),
            visible: addOrEditMailLocation.mode === 'add',
            onClick: createUpdateLocation
        },
        saveAddressButton: {
            visible: addOrEditMailLocation.mode === 'edit',
            onClick: createUpdateLocation
        },
        cancelAddressButton: {
            onClick: onCancelAddressClick
        },
        reasonForCancellation: {
            visible: _.get(submissionVM, 'baseData.hasCancelledByInsCompany_Ext.value') === true,
        },
        businessInfoTitle: {
            visible: offeringCode === "MotCyc"
        },
        businessInfoContainer: {
            visible: (offeringCode === "MotCyc" || offeringCode === "LifAge" ||
                offeringCode === "OffRoaVeh") && _.get(submissionVM, 'baseData.accountHolder.subtype.value') === "Company"
        },
        memberOfAssociationOrClub: {
            visible: offeringCode === "MotCyc" || offeringCode === "OffRoaVeh",
            path: offeringCode === "MotCyc" ? 'baseData.memberOfAssociationClubMC_Ext' : 'baseData.memberOfAssociationClubOffRoad_Ext',
            availableValues: getAssociationCodes()

        },
        existingPolicyNum: {
            visible: offeringCode === "OffRoaVeh"
        },
        cancelledByInsuranceCompany: {
            required: offeringCode === "MotCyc"
        },
        priorExpirationDate: {
            visible: offeringCode !== "VacTra"
        },
        ownership: {
            required: offeringCode === "MotCyc"
        },
        preferredlanguage_Ext: {
            onValueChange: (value) => {
                onPreferredLanguageChange(value);
            },
            availableValues: getPreferredLanguageAvailableValues(),
        },
        ifOthExp: {
            visible: !_.isUndefined(_.find(_.get(submissionVM.value, 'baseData.additionalNamedInsureds_Ext'), {
                            relationshipToNamedInsured: 'Oth'
                        })),
            required: !_.isUndefined(_.find(_.get(submissionVM.value, 'baseData.additionalNamedInsureds_Ext'), {
                            relationshipToNamedInsured: 'Oth'
                        }))
        }
    };

    const resolvers = {
        resolveComponentMap: {
            additionalInterestComponent: AdditionalInterestComponent,
            addressStandardizationComponent: AddressStandardizationComponent,
            searchContactComponent: SearchContactComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValueChangeTermType,
            onValueChangeCoverageStartDate
        }
    }

    const isPageInitialValidation = async () => {
        const isIntialValidation = await initialValidation()
        return isIntialValidation && !isNewSubmission
    };

    return (
        <WizardPage
            // showPrevious={false}
            skipWhen={isPageInitialValidation}
            disableNext={!isComponentValid}
            onNext={onNext}
            onSave={onSave}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </WizardPage>
    );
}

PolicyDetailsPage.propTypes = wizardProps;
export default withRouter(PolicyDetailsPage);